<template>
  <div class="social-icon" :class="provider" v-on:click="handlePin" :style="{width: size + 'px', height: size + 'px'}">
    <a ref="emailLink" :href="link"></a>
  </div>
</template>

<script>
export default {
  props: {
    provider: {
      type: String,
      default: 'pinterest',
    },
    url: String,
    media: String,
    message: String,
    caption: String,
    size: {
      type: Number,
      default: 32
    }
  },
  computed: {
    link: function () {
      let url = this.url
      if(!url.startsWith('http')) {
        url = this.getBaseUrl() + url
      }
      if(this.provider === 'email'){
        return 'mailto:?subject=' + encodeURIComponent(this.message) + '&body=' + 
          encodeURIComponent(this.caption) + encodeURIComponent('\n' + url + '\r\nvia illustrationx.com')
      }
      return ''
    }
  },
  mounted: function () {
    if(!window.FB) {
      console.log('no window.FB')
    }
    else {
      window.FB.init({ appId: '426375931294722', autoLogAppEvents : false, xfbml: false, version: 'v2.7'});
    }
    
  },
  methods: {
    handlePin: function () {
      if(!this.url) {
        this.url = this.getCurrentUrl()
      }
      let url = this.url
      let media = this.media
      
      if(!url.startsWith('http')) {
        url = this.getBaseUrl() + url
      }
      if(!media.startsWith('http')){
        media = this.getBaseUrl() + media
      }
      
      this.$k.sendSocialEvent(this.provider)
      
      if(this.provider === 'pinterest'){
        let link = "https://www.pinterest.com/pin/create/button/?url=" + encodeURIComponent(url) +
          "&media=" + encodeURIComponent(media) + "&description=" + encodeURIComponent(this.message);
        this.openPopupWindow(link, 700, 640)
      }
      else if(this.provider === 'facebook') {
        
        console.log('url is', url)
        // eslint-disable-next-line
        FB.ui(
          { 
            app_id: 426375931294722,
            method: 'share', 
            link: url, 
            caption: this.caption, 
            source: media, 
            href: url
          }, (response) => {
            console.log(response)
          });
      }
      else if(this.provider === 'twitter') {
        let link = "//twitter.com/intent/tweet?url=" + encodeURIComponent(url) +
        "&text=" + encodeURIComponent(this.message) + "&via=illustrationx.com";
        this.openPopupWindow(link, 700, 400)
      }
      else if(this.provider === 'email') {
        this.$refs.emailLink.click()
      }
    },
    getBaseUrl: function () {
      return window.location.protocol + '//' + window.location.host
    },
    getCurrentUrl: function () {
      return this.getBaseUrl() + this.$route.path
    },
    openPopupWindow: function (share_url, width, height) {
      let left = Math.round(screen.width / 2 - width / 2)
      let top = Math.round(screen.height / 2 - height / 2)
      const window_config = `width=${width},height=${height},left=${left},top=${top}`

      return window.open(
        share_url,
        "Share this",
        `${window_config},toolbar=no,menubar=no,scrollbars=no`
      )
    }
  }
}
</script>

<style>
.social-icon{
  background-repeat: no-repeat;
  background-size:contain;
  cursor:pointer;
  display:inline-block;
  background-position: center center;
}

.social-icon.pinterest{
  background-image:url('../../assets/img/pinterest-gold.svg');
}

.social-icon.pinterest:hover{
  background-image:url('../../assets/img/pinterest-red.svg');
}

.social-icon.facebook{
  background-image:url('../../assets/img/facebook-gold.svg');
}

.social-icon.facebook:hover{
  background-image:url('../../assets/img/facebook-red.svg');
}

.social-icon.twitter{
  background-image:url('../../assets/img/twitter-gold.svg');
}

.social-icon.twitter:hover{
  background-image:url('../../assets/img/twitter-red.svg');
}

.social-icon.email{
  background-image:url('../../assets/img/email-gold.svg');
}

.social-icon.email:hover{
  background-image:url('../../assets/img/email-red.svg');
}

</style>